/* eslint-disable @typescript-eslint/no-explicit-any */
import { axiosClient } from '../helpers/axiosClient';

export const FileManageServices = {
  getImage: (imageName: string) => {
    const url = `api/get-image/${imageName}`;
    return axiosClient.get(url, { responseType: 'blob' });
  },

  getAllFiles: () => {
    const url = `/api/user-file/all`;
    return axiosClient.get(url);
  },

  uploadFile: (files: any) => {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      const encodedFileName = encodeURIComponent(files[i]?.name);
      formData.append('files', files[i]?.originFileObj as Blob, encodedFileName);
    }
    const url = '/api/user-file'
    return axiosClient.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      
    });
  },

  updateUsing: (id: number, isUsing: boolean) => {
    const url = `/api/user-file/update-is-using`;
    return axiosClient.put(url, {
      id,
      isUsing,
    });
  },

  detele: (id: number) => {
    const url = `/api/user-file/${id}`;
    return axiosClient.delete(url);
  },

  deteleFromAI: (id: number) => {
    const url = `/api/user-file/delete-from-ai/${id}`;
    return axiosClient.delete(url);
  },
};